<template>
  <div id="banner" class="flex flex-col gap-4 py-20 px-10">
    <h3 class="text-3xl font-bold lg:text-4xl">Analistas XP</h3>
    <p class="text-sm lg:max-w-[50%] lg:text-base">
      Descubra as estratégias dos Analistas Grupo XP, opere como um profissional
      e potencialize seus investimentos com a combinação única de conhecimento,
      experiência de mercado e automação.
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#banner {
  background-image: url("/img/banner-analistas.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>
